import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { fromRole, fromSize, fromVisibility, Role, Size, Visibility } from './../buttons-utils';
import * as _ from 'lodash';

@Component({
    selector: 'a-button-default',
    templateUrl: './a-button-default.component.html',
    styleUrls: [
        './../buttons.scss',
        './a-button-default.component.scss'
    ],
    standalone: false
})

export class AButtonDefaultComponent {

    @Input()
    public disabled = false;

    @Input()
    public pulse = false;

    @Input()
    public visibility: Visibility = 'MEDIUM';

    @Input()
    public keyPressListener: string[] = [];

    @Input()
    public size: Size = 'DEFAULT';

    @Input()
    public role: Role = 'DEFAULT';

    public fromVisibility = fromVisibility;
    public fromSize = fromSize;
    public fromRole = fromRole;

    // tslint:disable-next-line:no-output-native
    @Output()
    public click: EventEmitter<MouseEvent> = new EventEmitter();

    constructor() {
    }

    @HostListener('document:keydown', ['$event'])
    onKeyPress(event: KeyboardEvent) {
        if (!this.disabled
            && this.keyPressListener.length
            && _.difference(this.keyPressListener, this.extractedKeys(event)).length === 0) {
            event.stopPropagation();
            this.click.emit();
        }
    }

    public doAction(event: MouseEvent): void {
        event.stopPropagation();
        if (!this.disabled) {
            this.click.emit(event);
        }
    }

    private extractedKeys(event: KeyboardEvent) {
        const keys: string[] = [(event.key || event.keyCode).toString()];
        if (event.metaKey) {
            keys.push('META');
        }
        if (event.ctrlKey) {
            keys.push('CTRL');
        }
        return keys.map(key => key.toUpperCase());
    }
}
